export default "__VITE_ASSET__w8rULeLj__"